import type {
  AttributeTarget,
  DeviceTarget,
  PageTarget,
  SurveyTargeting,
  UrlTarget,
} from '../../../../domain/Surveys/Survey/Survey';

export type PageTargetingMode = 'all' | 'specific';

export type UserTargetingMode = 'all' | 'specific';

export type AttributeTargetEntry = {
  id: string;
  target: AttributeTarget;
  error: string | undefined;
  isNew?: boolean;
};

export type DeviceTargetEntry = {
  id: string;
  target: DeviceTarget;
  error: string | undefined;
  isNew?: boolean;
};

export type UrlTargetEntry = {
  id: string;
  target: UrlTarget;
  error: string | undefined;
  isNew?: boolean;
};

export type PageTargetEntry = {
  id: string;
  target: PageTarget;
  error: string | undefined;
  isNew?: boolean;
};

export type TargetEntry = {
  id: string;
  target: SurveyTargeting;
  error: string | undefined;
  isNew?: boolean;
};

export const getTargetedDevices = (targeting: TargetEntry[]): DeviceTargetEntry[] => {
  return targeting.filter((rule): rule is DeviceTargetEntry => rule.target.component === 'device');
};

export const getTargetedPages = (targeting: TargetEntry[]): UrlTargetEntry[] => {
  return targeting.filter((rule): rule is UrlTargetEntry => rule.target.component === 'url');
};

export const getTargetedPagesAndTriggers = (targeting: TargetEntry[]): PageTargetEntry[] => {
  return targeting.filter(
    (rule): rule is PageTargetEntry =>
      rule.target.component === 'url' || rule.target.component === 'trigger',
  );
};

export const getTargetedUsers = (targeting: TargetEntry[]): AttributeTargetEntry[] => {
  return targeting.filter(
    (rule): rule is AttributeTargetEntry => rule.target.component === 'attribute',
  );
};

export const isTargetingAllPages = (targeting: TargetEntry[]): boolean => {
  const urlRules = getTargetedPages(targeting);
  return (
    urlRules.length === 1 &&
    urlRules[0].target.match_operation === 'contains' &&
    urlRules[0].target.pattern === '/'
  );
};

export const isTargetingAllUsers = (targeting: TargetEntry[]): boolean => {
  const userRules = getTargetedUsers(targeting);
  return userRules.length === 0;
};
